import heroSectionPhoto from "../../assets/landingPageItems/heroSectionPhoto.jpg";
import arrowRight from "../../assets/landingPageItems/right.svg";

const HeroSection = () => {
  return (
    <section className="w-full mt-12 grid grid-cols-1 md:grid-cols-2 items-center gap-6 py-8 md:py-12  bg-lightBlue">
      <div className="">
        <h1 className="text-[34px] xl:text-6xl my-4 font-audiowide text-white ">
          Tame Daily Sales Chaos&#8209;from POS And E&#8209;Commerce To
          <br />
          <span className="text-lightGreen">Bookkeeping-Ready Sheets</span>
        </h1>
        <p className="text-base md:text-lg md:max-w-md font-raleway text-white my-4 ">
          Transform messy sales exports into clean, bookkeeper-ready
          spreadsheets without any coding, manual cleanup or repetitive work
        </p>
        <button
          className="px-8 py-3 my-4 text-base font-raleway bg-lightGreen text-lightBlue rounded hover:bg-[#1db954cc] transition"
          onClick={() =>
            document
              .getElementById("howitworks")
              ?.scrollIntoView({ behavior: "smooth" })
          }
        >
          <div className="flex items-center">
            <span className="mr-2"> Discover More</span>
            <img src={arrowRight} alt="arrow right" className="" />
          </div>
        </button>
      </div>
      <img
        draggable="false"
        loading="lazy"
        src={heroSectionPhoto}
        alt="Accounting Illustration"
        className="w-full max-w-4xl object-cover max-h-[600px]  max-md:rounded-tl-3xl max-md:mt-12 max-md:ml-12 max-md:-mr-12 md:rounded-3xl max-md:max-w-xl bg-lightGreen max-md:pt-1 max-md:pl-1 md:pr-1 md:pb-1 shadow-lg"
      />
    </section>
  );
};

export default HeroSection;
